import React, { useMemo } from "react";
import { Checkbox } from "@mui/material";
import { CustomButton, VerticalDivider } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import styles from "./HeaderRow.module.css";
import { IS_V2 } from "../constants";

export default function HeaderRow({
	checkedAll,
	countChecked,
	currentCheckedList,
	currentList,
	onCheckAll,
	onOpenAssign,
}) {
	const selectedText = useMemo(
		() =>
			(countChecked > 1 &&
				translate("dsi.product-tour-management.affectation.side-panel.selected.multiple", {
					count: countChecked,
				})) ||
			translate("dsi.product-tour-management.affectation.side-panel.selected.single"),
		[countChecked]
	);
	return (
		<div className={styles.headerRow}>
			{!!onOpenAssign === IS_V2 && (
				<Checkbox
					checked={checkedAll}
					indeterminate={currentCheckedList.length > 0 && currentCheckedList.length < currentList.length}
					onChange={onCheckAll}
				/>
			)}
			{(countChecked === 0 && translate("common:name")) || (
				<div>
					<span className={styles.selectedText}>{selectedText}</span>
					{onOpenAssign && typeof onOpenAssign === "function" && (
						<>
							<VerticalDivider className={styles.verticalDivider} />
							<span className={styles.actionText}>{translate("common:actions")}</span>
							<CustomButton color="secondary" variant="outlined" onClick={onOpenAssign}>
								{translate("dsi.product-tour-management.affectation.action.assign")}
							</CustomButton>
						</>
					)}
				</div>
			)}
		</div>
	);
}
